<template>
  <v-dialog
    v-if="(typeof permissions.financial[subpage] !== 'undefined' && permissions.financial[subpage])"
    v-model="dialog"
    :fullscreen="is_mobile"
    :scrollable="false"
    overlay-opacity="50"
    max-width="70%"
    content-class="default-dialog"
  >
    <template v-slot:activator="{}">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            medium
            @click.stop="dialog = true"
            :disabled="get_interface.loading"
          >
            <v-icon medium>{{ lang.financial.periodicals.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.financial.periodicals.title }}</span>
      </v-tooltip>
    </template>
    <v-card class="default-dialog-card list-dialog-card">
      <v-card-title>
        <span class="headline">
          <v-icon>{{ lang.financial.periodicals.icon }}</v-icon>
          {{ `${lang.financial.periodicals.title} (${lang.financial[subpage].title})` }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-container
          class="overflow-y-auto dialog-scrollbar"
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
        >
          <div fluid class="catalog-page">
            <v-row>
              <Search name="financial.periodicals" />
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0">
                <List :subpage="subpage" />
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Search from '@/templates/global/Search'
import List from './templates/List'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Search, List },
  mixins: [ appdata, utils ],
  props: {
    subpage: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false
  }),
  watch: {
    dialog () {
      this.$store.dispatch('setGlobalSearch', { periodicals: '' })
    }
  }
}
</script>

<style src="./styles/index.scss" lang="scss"></style>
